<template>
  <div class="autoRedfundTask">
    <!-- 自动回评-创建模板组件 -->
    <el-drawer
      :visible.sync="drawer"
      direction="rtl"
      :with-header="false"
      style="height:1100px"
      :before-close="handleClose"
    >
      <div class="createTpl">
        <!-- 抽屉头部 -->
        <header class="head">
          <span>{{ title }}</span>
          <i class="el-icon-close close" @click="handleClose()"></i>
        </header>

        <!-- 表单内容 -->
        <div class="createTpl-scroll">
          <section class="createTplMain">
            <el-form ref="formSearch" :model="form" label-width="110px">
              <el-form-item label="任务名称:">
                <div class="sendMobile">
                  <el-input
                    placeholder="请输入任务名称"
                    v-model="form.taskName"
                    style="width: 280px"
                  ></el-input>
                </div>
              </el-form-item>

              <el-form-item label="自动审核时间:">
                <div class="taskTime">
                  <el-radio-group v-model="form.autoReplyType">
                    <el-radio :label="1">持续开启</el-radio>
                    <el-radio :label="2">指定时间</el-radio>
                  </el-radio-group>
                  <!-- <div class="my_select_time" style="marginLeft: 6px;">
                                    <el-date-picker
                                        prefix-icon="no_icon"
                                        v-model="form.startReplyTime"
                                        type="datetime"
                                        placeholder="开始日期"
                                        size="small"
                                        :disabled="taskTimeDisabled"
                                        format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 120px;"
                                        class="time1"
                                        :clearable="false">
                                    </el-date-picker>
                                    <div class="time_to_text">至</div>
                                    <el-date-picker
                                        prefix-icon="no_icon"
                                        v-model="form.endReplyTime"
                                        type="datetime"
                                        :disabled="taskTimeDisabled"
                                        placeholder="结束日期"
                                        size="small"
                                        format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        style="width: 145px;"
                                        class="time2"
                                        :clearable="false">
                                    </el-date-picker>
                                    <i class="el-icon-circle-close date_icon1" @click="clearTaskTime()"></i>
                                    <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
                </div>-->
                  <!--  -->
                  <el-time-select
                    v-model="form.startReplyTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:60',
                      end: '24:00',
                      maxTime: form.endReplyTime,
                    }"
                    placeholder="选择时间"
                    style="marginleft: 6px; width: 120px"
                  ></el-time-select>
                  <span>&nbsp;至&nbsp;</span>
                  <el-time-select
                    v-model="form.endReplyTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:60',
                      end: '24:00',
                      minTime: form.startReplyTime,
                    }"
                    placeholder="选择时间"
                    style="width: 120px"
                  ></el-time-select>
                </div>
              </el-form-item>

              <el-form-item label="通过条件:">
                <div class="condition">
                  <el-checkbox v-model="checkForm.adoptAuto"
                    >自动通过审核（满足以下条件的退款单自动审核通过）</el-checkbox
                  >
                  <div
                    style="margin-left: 40px"
                    v-if="checkForm.adoptAuto == true"
                  >
                    <div class="ition">
                      <el-checkbox v-model="checkForm.adoptNot"
                        >未出库订单自动审核通过</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          v-model="form.itemData[0].outStartRefundMoney"
                          style="width: 80px"
                          @input='$forceUpdate()'
                          @blur="
                            inputBlur($event, 0, 'outEndRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          v-model="form.itemData[0].outEndRefundMoney"
                          style="width: 80px"
                          @input='$forceUpdate()'
                          @blur="
                            inputBlur($event, 0, 'outStartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="ition">
                      <el-checkbox v-model="checkForm.adoptTrue"
                        >已出库订单自动审核</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          v-model="form.itemData[0].goingstartRefundMoney"
                          style="width: 80px"
                          @input='$forceUpdate()'
                          @blur="
                            inputBlur($event, 0, 'goingendRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          v-model="form.itemData[0].goingendRefundMoney"
                          style="width: 80px"
                          @input='$forceUpdate()'
                          @blur="
                            inputBlur($event, 0, 'goingstartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="adoptLine">
                      退款申请提交
                      <el-input
                        v-model="form.itemData[0].refundSubmitTime"
                        style="width: 120px"
                        @input='$forceUpdate()'
                      ></el-input
                      >小时后，系统自动通过审核（如果选择延时通过审核，系统会延时退款）
                    </div>
                    <div class="adoptRemark">
                      审核备注
                      <el-input
                        class="remarkArea"
                        type="textarea"
                        placeholder="请输入通过审核备注"
                        v-model="form.itemData[0].refundAuditRemark"
                        rows="2"
                        @input='$forceUpdate()'
                        style="width: 622px"
                      ></el-input>
                    </div>
                  </div>
                  <div style="margin-left: 40px" v-else>
                    <div class="ition">
                      <el-checkbox v-model="checkForm.adoptNot" disabled
                        >未出库订单自动审核通过</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          disabled
                          v-model="form.itemData[0].outStartRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 0, 'outEndRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          disabled
                          v-model="form.itemData[0].outEndRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 0, 'outStartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="ition">
                      <el-checkbox v-model="checkForm.adoptTrue" disabled
                        >已出库订单自动审核</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          disabled
                          v-model="form.itemData[0].goingstartRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 0, 'goingendRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          disabled
                          v-model="form.itemData[0].goingendRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 0, 'goingstartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="adoptLine">
                      退款申请提交
                      <el-input
                        disabled
                        v-model="form.itemData[0].refundSubmitTime"
                        style="width: 120px"
                      ></el-input
                      >小时后，系统自动通过审核（如果选择延时通过审核，系统会延时退款）
                    </div>
                    <div class="adoptRemark">
                      审核备注
                      <el-input
                        disabled
                        class="remarkArea"
                        type="textarea"
                        placeholder="请输入通过审核备注"
                        v-model="form.itemData[0].refundAuditRemark"
                        rows="2"
                        style="width: 622px"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="拒绝条件:">
                <div class="condition">
                  <el-checkbox v-model="checkForm.rejectAuto"
                    >自动通过审核（满足以下条件的退款单自动审核不通过）</el-checkbox
                  >
                  <div
                    style="margin-left: 40px"
                    v-if="checkForm.rejectAuto == true"
                  >
                    <div class="ition">
                      <el-checkbox v-model="checkForm.rejectNot"
                        >未出库订单自动审核通过</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          v-model="form.itemData[1].outStartRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'outEndRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          v-model="form.itemData[1].outEndRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'outStartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="ition">
                      <el-checkbox v-model="checkForm.rejectTrue"
                        >已出库订单自动审核</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          v-model="form.itemData[1].goingstartRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'goingendRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          v-model="form.itemData[1].goingendRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'goingstartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="adoptLine">
                      退款申请提交
                      <el-input
                        v-model="form.itemData[1].refundSubmitTime"
                        style="width: 120px"
                      ></el-input
                      >小时后
                    </div>
                    <div class="adoptRemark">
                      拒绝理由
                      <el-select
                        v-model="form.itemData[1].rejectType"
                        style="width: 300px; margin-left: 12px"
                      >
                        <el-option
                          v-for="item in refuseOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <!-- <el-input
                                        class="remarkArea"
                                        type="textarea"
                                        placeholder="请输入拒绝理由"
                                        v-model=""
                                        rows="2"
                                        style="width: 622px;">
                  </el-input>-->
                    </div>
                    <div class="adoptRemark">
                      审核备注
                      <el-input
                        class="remarkArea"
                        type="textarea"
                        placeholder="请输入拒绝审核备注"
                        v-model="form.itemData[1].refundAuditRemark"
                        rows="2"
                        style="width: 622px"
                      ></el-input>
                    </div>
                  </div>
                  <div style="margin-left: 40px" v-else>
                    <div class="ition">
                      <el-checkbox v-model="checkForm.rejectNot" disabled
                        >未出库订单自动审核通过</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          disabled
                          v-model="form.itemData[1].outStartRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'outEndRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          disabled
                          v-model="form.itemData[1].outEndRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'outStartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="ition">
                      <el-checkbox v-model="checkForm.rejectTrue" disabled
                        >已出库订单自动审核</el-checkbox
                      >
                      <div class="itionIpt">
                        退款金额
                        <el-input
                          disabled
                          v-model="form.itemData[1].goingstartRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'goingendRefundMoney', 'max')
                          "
                        ></el-input
                        >~
                        <el-input
                          disabled
                          v-model="form.itemData[1].goingendRefundMoney"
                          style="width: 80px"
                          @blur="
                            inputBlur($event, 1, 'goingstartRefundMoney', 'min')
                          "
                        ></el-input
                        >（不填则不限制）
                      </div>
                    </div>
                    <div class="adoptLine">
                      退款申请提交
                      <el-input
                        disabled
                        v-model="form.itemData[1].refundSubmitTime"
                        style="width: 120px"
                      ></el-input
                      >小时后
                    </div>
                    <div class="adoptRemark">
                      拒绝理由
                      <el-select
                        disabled
                        v-model="form.itemData[1].rejectType"
                        style="width: 300px; margin-left: 12px"
                      >
                        <el-option
                          v-for="item in refuseOptions"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <!-- <el-input
                                        class="remarkArea"
                                        type="textarea"
                                        placeholder="请输入拒绝理由"
                                        v-model=""
                                        rows="2"
                                        style="width: 622px;">
                  </el-input>-->
                    </div>
                    <div class="adoptRemark">
                      审核备注
                      <el-input
                        disabled
                        class="remarkArea"
                        type="textarea"
                        placeholder="请输入拒绝审核备注"
                        v-model="form.itemData[1].refundAuditRemark"
                        rows="2"
                        style="width: 622px"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </el-form-item>

              <el-form-item label="短信通知:">
                <el-checkbox v-model="form.reminderSellerStatus"
                  >退款单自动审核后通知我</el-checkbox
                >
              </el-form-item>

              <el-form-item label="发送号码:">
                <div class="sendMobile">
                  <!-- <el-input
                    placeholder="多个号码请用“,”隔开"
                    v-model="form.receiveMobile"
                    @change="sendMobileChange"
                    style="width: 280px"
                  ></el-input> -->
                  <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                      <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                  <button class="sendSmsTest" @click.prevent="sendSmsTest">
                    发送短信测试
                  </button>
                  <button class="smsRecord" @click.prevent="smsDialogs = true">短信记录</button>
                  <button class="smsRecord" style="width: auto;margin-left: 8px;" @click.prevent="showchangetestphone = true" >修改测试手机号</button>
                </div>
              </el-form-item>

              <!-- <el-form-item label="通知时间:">
                            <div class="my_select_time" style="marginLeft: 6px;">
                                <el-date-picker
                                    prefix-icon="no_icon"
                                    v-model="form.noticeTimeStart"
                                    type="datetime"
                                    placeholder="开始日期"
                                    size="small"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    style="width: 120px;"
                                    class="time1"
                                    :clearable="false">
                                </el-date-picker>
                                <div class="time_to_text">至</div>
                                <el-date-picker
                                    prefix-icon="no_icon"
                                    v-model="form.noticeTimeEnd"
                                    type="datetime"
                                    placeholder="结束日期"
                                    size="small"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    style="width: 145px;"
                                    class="time2"
                                    :clearable="false">
                                </el-date-picker>
                                <i class="el-icon-circle-close date_icon1" @click="clearTaskTime()"></i>
                                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
                            </div>
            </el-form-item>-->

              <el-form-item label="短信内容:">
                <el-input
                  type="textarea"
                  placeholder="请输入短信内容"
                  v-model="form.content"
                  rows="2"
                  disabled
                  style="width: 622px"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>

          <!-- 底部按钮 -->
          <footer class="footBtn">
            <button class="keepOpenBtn" @click="keepOpen(true)">
              保存并开启
            </button>
            <button class="keepBtn" @click="keepOpen(false)">保存设置</button>
          </footer>
        </div>
      </div>
    </el-drawer>
    <!-- 发送确认 -->
    <my-popup
      v-if="sendSmsTestState"
      :flag="sendSmsTestState"
      title="发送确认"
      @close="sendSmsTestClose"
      width="500"
    >
      <div class="sendSmsTestWrap">
        <p class="detailsInfo">
          <span
            >提交号码为
            {{
              form.receiveMobile && form.receiveMobile.split(",").length
            }}</span
          >
          当前短信字数为 {{ form.content.length }} 字，每条短信以
          {{
            Math.ceil(
              form.content.length > 70
                ? form.content.length / 67
                : form.content.length / 70
            )
          }}
          条计费，
          <span
            >提交
            {{
              form.receiveMobile &&
                form.receiveMobile.split(",").length *
                  Math.ceil(
                    form.content.length > 70
                      ? form.content.length / 67
                      : form.content.length / 70
                  )
            }}
            条短信，以实际发送条数为准！</span
          >
        </p>
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="sendSmsTestState = false">取消</el-button>
      </div>
    </my-popup>
    <smsTemplates v-if="smsDialogs" :smsDialog="smsDialogs" @transferName="smsDialogs = false"></smsTemplates>
        
    <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import myPopup from "@/components/myPopup";
import { addAutoAuditRefund } from "@/api/serviceCenter/autoRefund";
import { preCommit,NewPreCommit, platformSend,getValidSmsTestMobiles } from "@/api/smsSend";
import changetestphone from "@/components/changetestphone.vue";
import smsTemplates from "@/components/sms-templates-x";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
    title: {
      type: String,
    },
  },
  components: {
    myPopup,
    changetestphone,
    smsTemplates
  },
  watch: {
    drawer(newVal) {
      console.log("this.editData", this.editData);
      if (newVal) {
        if (this.editData) this.form = this.editData;
        const { autoAcceptStatus, autoRejectStatus } = this.form;
        this.form.reminderSellerStatus =
          this.form.reminderSellerStatus == 1 ? false : true;
        if (autoAcceptStatus == 2) this.checkForm.adoptAuto = true;
        if (autoRejectStatus == 2) this.checkForm.rejectAuto = true;
        switch (this.form.itemData[0].refundOutgoingState) {
          case 3:
            this.checkForm.adoptNot = true;
            this.checkForm.adoptTrue = true;
            break;
          case 2:
            this.checkForm.adoptTrue = true;
            break;
          case 1:
            this.checkForm.adoptNot = true;
        }
        switch (this.form.itemData[1].refundOutgoingState) {
          case 3:
            this.checkForm.rejectNot = true;
            this.checkForm.rejectTrue = true;
            break;
          case 2:
            this.checkForm.rejectTrue = true;
            break;
          case 1:
            this.checkForm.rejectNot = true;
        }
      }
    },
  },
  computed: {
    // 任务时间日期选择器是否禁用
    taskTimeDisabled() {
      return this.form.taskTime === 0 ? true : false;
    },
  },
  mounted() {
    this.getValidSmsTestMobiles()
  },
  data() {
    return {
      smsDialogs:false,
      textPhoneId:"",
      nowtestMobiles:"",
      showchangetestphone:false,
      testOptions: [], // 获取测试手机号
      Selectmobiles:[],

      checkForm: {
        adoptAuto: false,
        adoptNot: false,
        adoptTrue: false,
        rejectAuto: false,
        rejectNot: false,
        rejectTrue: false,
      },
      form: {
        itemData: [
          // conditionType: 1 通过条件 2 拒绝条件
          {
            refundOutgoingState: 4,
            outStartRefundMoney: null,
            outEndRefundMoney: null,
            goingstartRefundMoney: null,
            goingendRefundMoney: null,
            refundSubmitTime: 0,
            refundAuditRemark: null,
            conditionType: 1,
          },
          {
            refundOutgoingState: 4,
            outStartRefundMoney: null,
            outEndRefundMoney: null,
            goingstartRefundMoney: null,
            goingendRefundMoney: null,
            refundSubmitTime: 0,
            rejectType: 1,
            refundAuditRemark: null,
            conditionType: 2,
          },
        ],
        taskName: "自动审核退款",
        autoReplyType: 1,
        startReplyTime: null,
        endReplyTime: null,
        reminderSellerStatus: false,
        receiveMobile: null,
        content:
          "【云起科技】您的京东店铺订单#订单号#退款已自动#审核退款结果#，退款金额：#退款金额#元。拒收请回复R",
        autoAcceptStatus: 1,
        autoRejectStatus: 1,
        isOpen: 1,
      },
      refuseOptions: [
        { label: "商品已在配送途中，无法取消", id: 1 },
        { label: "商品已签收，无法取消", id: 2 },
        { label: "国际站保税区订单，已报关", id: 3 },
        { label: "已电话沟通客户，客户同意签收商品", id: 4 },
        { label: "其他", id: 5 },
        { label: "商品已在配送途中，无法取消", id: 6 },
      ],
      sendSmsTestState: false,
    };
  },
  methods: {
    mobilPhoneSubmit(val){
      this.getValidSmsTestMobiles()
      this.showchangetestphone = false
    },
    getValidSmsTestMobiles() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.Selectmobiles = [];
          this.testOptions = res.data.smsTestMobiles
          this.nowtestMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.form.receiveMobile = this.Selectmobiles.join(',')
    },
    /**
     * 保存并开启 || 保存设置
     */
    keepOpen(isOpen) {
      const {
        adoptAuto,
        adoptNot,
        adoptTrue,
        rejectAuto,
        rejectNot,
        rejectTrue,
      } = this.checkForm;

      let params = this.deepCopy(this.form);
      params.startReplyTime = params.startReplyTime
        ? parseInt(params.startReplyTime)
        : params.startReplyTime;
      params.endReplyTime = params.endReplyTime
        ? parseInt(params.endReplyTime)
        : params.endReplyTime;
      params.isOpen = isOpen ? 1 : 0;
      if (!adoptAuto) {
        params.autoAcceptStatus = 1;
        params.itemData.splice(0, 1);
      } else {
        const state =
          adoptNot && adoptTrue ? 3 : adoptNot ? 1 : adoptTrue ? 2 : 4;
        params.itemData[0].refundOutgoingState = state;
        params.autoAcceptStatus = 2;
      }
      if (!rejectAuto) {
        params.itemData.length > 1
          ? params.itemData.splice(1, 1)
          : params.itemData.splice(0, 1);
      } else {
        const state =
          rejectNot && rejectTrue ? 3 : rejectNot ? 1 : rejectTrue ? 2 : 4;
        params.itemData.length > 1
          ? (params.itemData[1].refundOutgoingState = state)
          : (params.itemData[0].refundOutgoingState = state);
        params.autoRejectStatus = 2;
      }
      params.reminderSellerStatus
        ? (params.reminderSellerStatus = 2)
        : (params.reminderSellerStatus = 1);
      params.content = '您的京东店铺订单#订单号#退款已自动#审核退款结果#，退款金额：#退款金额#元。'
      addAutoAuditRefund(params).then((res) => {
        if (res && res.code == 1) {
          this.$message.success("保存成功");
          this.handleClose(true);
        } else {
          this.$message.warning(res && res.message);
        }
      });
    },
    handleClose(state) {
      // 重置数据
      this.checkForm = {
        adoptAuto: false,
        adoptNot: false,
        adoptTrue: false,
        rejectAuto: false,
        rejectNot: false,
        rejectTrue: false,
      };
      (this.form = {
        itemData: [
          {
            refundOutgoingState: 4,
            outStartRefundMoney: null,
            outEndRefundMoney: null,
            goingstartRefundMoney: null,
            goingendRefundMoney: null,
            refundSubmitTime: 0,
            refundAuditRemark: null,
            conditionType: 1,
          },
          {
            refundOutgoingState: 4,
            outStartRefundMoney: null,
            outEndRefundMoney: null,
            goingstartRefundMoney: null,
            goingendRefundMoney: null,
            refundSubmitTime: 0,
            rejectType: 1,
            refundAuditRemark: null,
            conditionType: 2,
          },
        ],
        taskName: "自动审核退款",
        autoReplyType: 1,
        startReplyTime: null,
        endReplyTime: null,
        reminderSellerStatus: false,
        receiveMobile: null,
        content:
          "【云短信】您的京东店铺订单#订单号#退款已自动#审核退款结果#，退款金额：#退款金额#元。",
        autoAcceptStatus: 1,
        autoRejectStatus: 1,
      }),
        state ? this.$emit("close", true) : this.$emit("close", false);
    },
    /**
     * 清除任务时间
     */
    clearTaskTime() {
      this.form.startReplyTime = null;
      this.form.endReplyTime = null;
    },
    // 短信测试发送号码变化监听
    sendMobileChange() {
      const { receiveMobile } = this.form;
      this.form.receiveMobile =
        receiveMobile && receiveMobile.replace("，", ",");
    },
    // 发送短信测试
    sendSmsTest() {
      const { content } = this.form;
      if (!content || !content.trim()) {
        this.$message.warning("请输入短信内容 !");
        return;
      }
      this.sendSmsTestState = true;
    },
    // 发送短信-预提交
    handleSendConfirm() {
      const params = {
        mobiles: this.form.receiveMobile,
        sendType: 0,
        dataFrom: 0,
        checkInvalidChar: false,
      };
      // preCommit(params).then((res) => {
      let postData = {
        content: this.form.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles,
        checkInvalidChar:false,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          this.$message.success(res.data)
          this.sendSmsTestState = false;
        }else{
          this.sendSmsTestState = false;
          this.$message.error(res.message)
        }
        // res && this.sendSms(res.data.sendObjectId);
      });
    },
    // 发送短信-正式
    sendSms(id) {
      const params = {
        sendObjectId: id,
        blackFlag: false,
        smsSuffix: "【云起科技】",
        content: this.form.content,
        smsType: 0
      };
      platformSend(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("发送成功!");
        } else {
          this.$message.warning(res.message);
        }
        this.sendSmsTestState = false;
      });
    },
    sendSmsTestClose() {
      this.sendSmsTestState = false;
    },
    inputBlur(e, num, field, type) {
      const curValue = +e.target.value;
      let value = this.form.itemData[num][field];
      if (value) {
        if (type == "max" && curValue > +value)
          this.form.itemData[num][field] = null;
        if (type == "min" && value > curValue) {
          e.target.value = null;
        }
      }
    },
    deepCopy(obj) {
      var result = Array.isArray(obj) ? [] : {};
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            result[key] = this.deepCopy(obj[key]); //递归复制
          } else {
            result[key] = obj[key];
          }
        }
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer {
  width: 894px !important;
}
/deep/ .el-date-editor--time-select{
  .el-icon-time{
    display: none;
  }
}
.createTpl {
  display: flex;
  flex-direction: column;
  height: 100%;
  // overflow-y: scroll;
  .head {
    flex-grow: 0;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 28px;
    height: 60px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    .close {
      cursor: pointer;
      color: #ccc;
    }
  }
  .createTpl-scroll {
    overflow-y: scroll;
    height: 850px;
    .createTplMain {
      flex: 1;
      box-sizing: border-box;
      padding: 16px 0 0 38px;
      .selectBtn {
        width: 126px;
        height: 32px;
        border-radius: 3px;
        cursor: pointer;
        outline: none;
        color: #fe4d45;
        background-color: #fff4f4;
        &:hover {
          color: #fe4d45;
          background-color: #ffe5e5;
        }
      }
      .ition {
        display: flex;
        align-items: center;
        margin-top: 12px;
        color: #606266;
        .itionIpt {
          margin-left: 10px;
        }
      }
      .adoptLine {
        margin-top: 12px;
        color: #606266;
      }
      .adoptRemark {
        display: flex;
        align-items: flex-start;
        margin-top: 12px;
        color: #606266;
        .remarkArea {
          margin-left: 12px;
        }
      }
      .disabled {
        background: rgba(246, 246, 246, 1);
        border: 1px solid rgba(238, 238, 238, 1);
        color: #999;
        cursor: not-allowed;
      }
      .marleft {
        margin-left: 6px;
      }
      .sendMobile {
        display: flex;
        align-items: center;
        button {
          width: 98px;
          height: 32px;
          line-height: 28px;
          text-align: center;
          background-color: white;
          border: none;
          outline: none;
          cursor: pointer;
          border-radius: 3px;
          font-size: 14px;
          font-weight: 400;
          transition: all 0.2s;
        }
        .sendSmsTest {
          width: 120px;
          margin: 0 8px 0 12px;
          border: 1px solid #fe4d45;
          color: #fe4d45;
          &:hover {
            background-color: #fe4d45;
            color: #fff;
          }
        }
        .smsRecord {
          border: 1px solid #ccc;
          color: #999;
          &:hover {
            border: 1px solid #fe4d45;
            color: #fe4d45;
          }
        }
      }
    }
    .footBtn {
      flex-grow: 0;
      flex-shrink: 0;
      box-sizing: border-box;
      padding-left: 48px;
      height: 60px;
      line-height: 60px;
      border-top: 1px solid #f0f0f0;
      .keepOpenBtn,
      .keepBtn {
        width: 98px;
        height: 32px;
        font-size: 14px;
        font-weight: 400;
        outline: none;
        background-color: white;
        border: none;
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .keepOpenBtn {
        margin-right: 12px;
        color: #fff;
        background-color: #fe4d45;
        &:hover {
          opacity: 0.9;
        }
      }
      .keepBtn {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        &:hover {
          background-color: #fe4d45;
          color: #fff;
        }
      }
    }
  }
}
.sendSmsTestWrap {
  text-align: center;
  p {
    margin: 40px 0;
  }
}
</style>
<style rel="stylesheet/scss" lang="scss">
.el-drawer.rtl {
  overflow: scroll;
}
</style>
